import { Box, Typography } from '@mui/material';

/** One labelled figure in the row above a report, with an optional line of context under it. */
const ReportFigure = ({ label, value, hint }: { label: string, value: string, hint?: string }) => (
  <Box sx={{ minWidth: 130 }}>
    <Typography variant='caption' color='text.secondary' display='block'>{label}</Typography>
    <Typography variant='h6' sx={{ lineHeight: 1.2 }}>{value}</Typography>
    {hint && <Typography variant='caption' color='text.secondary'>{hint}</Typography>}
  </Box>
);

export default ReportFigure;
